"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.belarusTranslations = void 0;
var _types = require("../../../types");
const belarusTranslations = exports.belarusTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Нам очень жаль!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Назад',
  [_types.ErrorPageTranslationKey.text]: 'Эта страница в настоящий момент недоступна',
  [_types.ErrorPageTranslationKey.notFound]: 'Старонка, якую вы шукаеце, не даступная',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Сторонка, якую вы спрабуеце дасягнуць, абмежаваная і не ўсе крытэрыі былі суправаджаны.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Калі ласка, звяжыцеся са службай падтрымкі Oriflame па электроннай пошце:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Запытаны URL быў адхілены!'
};
